import { HeNotification } from '../../../../../../common/components/HeNotification/HeNotification';
import { TELEHEALTH_SERVICES_LANDING_URL } from '../../../../../../common/constants';
import { FontSize, FontWeight } from '../../../../../../common/styles/constants';
import { StyledLink } from './TelehealthAfterHourInfoBox.styles';

export const TelehealthAfterHourInfoBox = () => (
  <HeNotification
    hasIcon
    title="See a doctor after hours via Telehealth"
    titleStyle={{ fontWeight: FontWeight.BOLD, fontSize: FontSize.BODY_REGULAR }}
  >
    General consults, scripts and medical certificates{' '}
    <StyledLink
      to={`${TELEHEALTH_SERVICES_LANDING_URL}?icid=tel:serp:inb:gps::gp:ctb:afh::jun22`}
      newTab
    >
      See Telehealth Featured Partners
    </StyledLink>
  </HeNotification>
);
